import React from 'react'
import { connect } from 'react-redux'
import PopperJS from 'popper.js'
import PropTypes from 'prop-types'
import styles from './context-menu.css'
import clsx from 'clsx'

import { hideContextMenu } from '../../../../redux/ducks/listContextMenu'
import theme from '@/theme'

class ContextMenu extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isVisible: false,
    }

    this.update = this.update.bind(this)
    this.closeContextMenu = this.closeContextMenu.bind(this)
    this.offsetTopModifier = this.offsetTopModifier.bind(this)
  }

  componentDidMount() {
    this.addPopper(this.props)
  }

  componentWillReceiveProps(props) {
    this.addPopper(props)
  }

  componentWillUnmount() {
    const { hideContextMenu } = this.props
    this.popper && this.popper.destroy()
    this.raf && window.cancelAnimationFrame(this.raf)
    hideContextMenu()
  }

  closeContextMenu() {
    const { closeContextMenuCalled } = this.props
    this.popper && this.popper.destroy()
    closeContextMenuCalled && closeContextMenuCalled()
  }

  offsetTopModifier(data) {
    const { offsetTop } = this.props
    data.offsets.popper.top += Math.round(offsetTop || 0)
    return data
  }

  addPopper(props) {
    const { target, offset, placement } = props

    this.popper && this.popper.destroy()
    this.popper = new PopperJS(target, this.refs.content, {
      placement,
      flip: ['top'],
      arrowElement: this.refs.arrow,
      offset: offset || 3,
      escapeWithReference: true,
      modifiers: ['shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', this.offsetTopModifier, 'applyStyle'],
    })

    this.popper.onUpdate((data) => {
      this.setState({ data })
    })

    this.update()
    this.setState({ isVisible: true })
  }

  update() {
    this.raf = this.raf || window.requestAnimationFrame(this.update)
    this.popper && this.popper.update()
  }

  getPopperStyle(data) {
    if (!data) { return {} }

    const left = Math.round(data.offsets.popper.left)
    const top = Math.round(data.offsets.popper.top)
    const transform = `translate3d(${left}px, ${top}px, 0)`
    return {
      position: data.offsets.popper.position,
      transform,
      WebkitTransform: transform,
      top: 0,
      left: 0,
      zIndex: 100,
      background: '#fff',
      border: theme.border,
      fontSize: '14px',
      borderRadius: '4px',
    }
  }

  render() {
    const { data, isVisible } = this.state
    const { children, className } = this.props

    return (
      <div>
        <div className={styles.overlay} onClick={this.closeContextMenu}></div>
        <div
          ref='content'
          data-placement={data && data.placement}
          className={clsx('context', className, !isVisible && 'u_hidden')}
          style={this.getPopperStyle(data)}>
          {children}
          <div ref='arrow' className='context_arrow'>
            <div className='context_arrow_outer' />
            <div className='context_arrow_inner' />
          </div>
        </div>
      </div>
    )
  }
}

ContextMenu.propTypes = {
  placement: PropTypes.string,
  items: PropTypes.array,
  target: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.node,
  closeContextMenuCalled: PropTypes.func,
}
ContextMenu.defaultProps = {
  placement: 'bottom-end',
  target: undefined,
  items: [],
}

const mapDispatchToProps = (dispatch) => {
  return {
    hideContextMenu: () => { dispatch(hideContextMenu()) },
  }
}

export default connect(null, mapDispatchToProps)(ContextMenu)
